import { ModalId, useUIActions } from "../../../../../features/ui"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { Data2 } from "../../../../../features/data-types"
import { useBudgetService } from "../../../services/budgetService"

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()

    const { openModal } = useUIActions()
    
    const { createBudget } = useBudgetService()

    const submitBudget = async (
        data: Data2,
        sellerId: string,
        customerId: string,
        itemsData: Data2[]
    ) => {
        const { date, customerTypeId } = data
        const budgetData = {
            date,
            sellerId,
            customerId,
            customerTypeId
        }
        
        const savedBudget = await createBudget(budgetData, itemsData)
        
        Emitter.emit(Event.DB_SUBMIT_DONE, true, false, getRoutePath(RoutePath.BUDGETS, savedBudget.id))
        setTimeout(() => openModal(ModalId.DOWNLOAD_BUDGET_PDF), 1000)
    }

    return {
        submitBudget
    }
}
